/* voyabarefoot — PDP clonada (bloco cl_pdp dentro da main-product nativa).
   Variantes (swatch de cor + select de tamanho) -> variante; atualiza preco/selo/estoque/ATC/URL e o
   input `id` do form NATIVO do buy_buttons (o botao copiado envia esse form via form="...").
   Galeria do Dawn dele: miniaturas, setas, contador, arraste com mouse (desktop), toque nativo
   (scroll-snap no mobile). Tabela de medidas (.overlay_size) e o slot do app (Kaching). */
(function(){
  if (window.__clPdp) return; window.__clPdp = true;

  function money(c, fmt){
    fmt = fmt || '${{amount}}';
    function f(n, dec, th, ds){ var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return s[0] + (s[1] ? ds + s[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_with_comma_separator') return f(c, 2, '.', ',');
      if (k === 'amount_no_decimals') return f(c, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return f(c, 0, '.', ',');
      return f(c, 2, ',', '.'); });
  }

  function initGallery(root){
    var list = root.querySelector('.clx-product__media-list');
    var thumbs = root.querySelector('.clx-thumbnail-list');
    if (!list) return null;
    var slides = [].slice.call(list.querySelectorAll('.clx-product__media-item'));
    var tItems = thumbs ? [].slice.call(thumbs.querySelectorAll('.clx-thumbnail-list__item')) : [];
    var cur = root.querySelector('.slider-counter--current');
    var mobile = function(){ return window.innerWidth < 750; };
    var idx = Math.max(0, slides.findIndex(function(s){ return s.classList.contains('clx-is-active'); }));

    function setActive(i, scroll){
      if (i < 0 || i >= slides.length) return;
      idx = i;
      slides.forEach(function(s, k){ s.classList.toggle('clx-is-active', k === i); });
      tItems.forEach(function(t, k){
        var b = t.querySelector('button'); if (!b) return;
        if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      if (cur) cur.textContent = i + 1;
      if (scroll !== false && mobile()) list.scrollTo({left: slides[i].offsetLeft - list.offsetLeft, behavior: 'smooth'});
      var t = tItems[i];
      if (t && thumbs) {
        var l = t.offsetLeft - thumbs.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbs.scrollLeft || r > thumbs.scrollLeft + thumbs.clientWidth)
          thumbs.scrollTo({left: l - (thumbs.clientWidth - t.offsetWidth) / 2, behavior: 'smooth'});
      }
    }
    tItems.forEach(function(t, k){
      var b = t.querySelector('button');
      if (b) b.addEventListener('click', function(e){ if (t.__clDragged) { t.__clDragged = false; return; } setActive(tItems.indexOf(t)); });
    });
    /* setas do slider principal (mobile) e das miniaturas */
    var mainBtns = root.querySelectorAll('.clx-slider-buttons .clx-slider-button');
    mainBtns.forEach(function(b){
      b.addEventListener('click', function(){ setActive(idx + (b.name === 'next' ? 1 : -1)); });
    });
    var tBtns = root.querySelectorAll('.clx-thumbnail-slider > .clx-slider-button');
    tBtns.forEach(function(b){
      b.addEventListener('click', function(){
        var n = b.name === 'next' ? 1 : -1;
        if (mobile()) setActive(idx + n);
        else setActive(Math.min(slides.length - 1, Math.max(0, idx + n)));
      });
    });
    /* mobile: o toque rola o trilho (scroll-snap); o contador acompanha */
    var st;
    list.addEventListener('scroll', function(){
      if (!mobile()) return;
      clearTimeout(st); st = setTimeout(function(){
        var x = list.scrollLeft, best = 0, bd = 1e9;
        slides.forEach(function(s, k){ var d = Math.abs(s.offsetLeft - list.offsetLeft - x); if (d < bd) { bd = d; best = k; } });
        if (best !== idx) setActive(best, false);
      }, 80);
    }, {passive: true});
    /* arraste com mouse: no desktop troca a foto; no trilho de miniaturas rola */
    function dragSwitch(el){
      var down = false, sx = 0, moved = false;
      el.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = e.clientX; });
      window.addEventListener('pointerup', function(e){
        if (!down) return; down = false;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 40) { moved = true; setActive(idx + (dx < 0 ? 1 : -1)); }
      });
      el.addEventListener('click', function(e){ if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      el.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }
    function dragScroll(el){
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; el.style.scrollSnapType = 'none'; el.style.scrollBehavior = 'auto'; });
      window.addEventListener('pointermove', function(e){ if (!down) return; var dx = e.clientX - sx;
        if (Math.abs(dx) > 5) moved = true; if (moved) el.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function(){ if (!down) return; down = false; el.style.scrollSnapType = ''; el.style.scrollBehavior = '';
        if (moved) tItems.forEach(function(t){ t.__clDragged = true; setTimeout(function(){ t.__clDragged = false; }, 50); }); });
      el.addEventListener('dragstart', function(e){ e.preventDefault(); });
    }
    dragSwitch(list);
    if (thumbs) dragScroll(thumbs);
    return {toMedia: function(mediaId){
      var i = slides.findIndex(function(s){ return (s.getAttribute('data-media-id') || '').split('-').pop() == String(mediaId); });
      if (i < 0) return;
      /* Dawn dele (hide variants): a foto da variante escolhida vira o 1o item; as outras fotos de
         variante seguem ocultas pelo CSS (.media-item--variant:not(:first-child)) */
      var s = slides[i];
      if (s.classList.contains('clx-product__media-item--variant')) {
        list.insertBefore(s, list.firstElementChild);
        slides.splice(i, 1); slides.unshift(s);
        if (tItems[i] && thumbs) {
          var t = tItems[i], ul = t.parentNode;
          ul.insertBefore(t, ul.firstElementChild);
          tItems.splice(i, 1); tItems.unshift(t);
        }
        i = 0;
        if (!mobile()) window.scrollTo({top: Math.max(0, list.getBoundingClientRect().top + window.scrollY - 120), behavior: 'smooth'});
      }
      setActive(i);
    }};
  }

  function initVariants(root, gal){
    var data = JSON.parse((root.querySelector('script[data-cl-product]') || {}).textContent || '{}');
    var variants = data.variants || [];
    var formId = root.getAttribute('data-form-id');
    function opts(){
      var out = [];
      root.querySelectorAll('[data-cl-opt-input]').forEach(function(el){
        var i = +el.getAttribute('data-cl-opt-input');
        if (el.type === 'radio') { if (el.checked) out[i] = el.value; }
        else out[i] = el.value;
      });
      return out;
    }
    function find(o){
      return variants.find(function(v){ return v.options.every(function(x, i){ return o[i] === undefined || o[i] === x; }); });
    }
    function update(){
      var o = opts(), v = find(o);
      root.querySelectorAll('[data-selected-swatch-value]').forEach(function(s){
        var fs = s.closest('fieldset'); var c = fs && fs.querySelector('input:checked'); if (c) s.textContent = c.value; });
      root.querySelectorAll('[data-cl-sel-label]').forEach(function(s){
        var i = s.getAttribute('data-cl-sel-label'); var sel = root.querySelector('select[data-cl-opt-input="' + i + '"]'); if (sel) s.textContent = sel.value; });
      var btn = root.querySelector('[data-cl-atc]');
      if (!v) { if (btn) { btn.disabled = true; var sp0 = btn.querySelector('span'); if (sp0) sp0.textContent = 'Unavailable'; } return; }
      var f = document.getElementById(formId);
      if (f) { var inp = f.querySelector('input[name="id"]'); if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles: true})); } }
      var inst = document.getElementById('cl-installment-form'); if (inst) { var ii = inst.querySelector('input[name="id"]'); if (ii) ii.value = v.id; }
      var fmt = data.money;
      root.querySelectorAll('[data-cl-price-now]').forEach(function(e){ e.textContent = money(v.price, fmt); });
      root.querySelectorAll('[data-cl-price-cmp]').forEach(function(e){ e.textContent = money(v.compare_at_price || 0, fmt); });
      var pr = root.querySelector('[data-cl-price]');
      if (pr) pr.classList.toggle('clx-price--on-sale', (v.compare_at_price || 0) > v.price);
      var sv = root.querySelector('[data-cl-save]');
      if (sv) sv.textContent = (v.compare_at_price || 0) > v.price ? 'You saved ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%' : '';
      if (btn) { btn.disabled = !v.available; var sp = btn.querySelector('span'); if (sp) sp.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.featured_media && gal) gal.toMedia(v.featured_media.id);
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    root.querySelectorAll('[data-cl-opt-input]').forEach(function(el){ el.addEventListener('change', update); });
  }

  function initSizeChart(root){
    var ov = root.querySelector('.overlay_size'); if (!ov) return;
    document.body.appendChild(ov);   /* fora do container da main (z-index/stacking) */
    ov.style.zIndex = '2147482990';
    /* o CSS do overlay (.cl-size-ov) nao e escopado: aqui fora da secao `.cl-sec-pd00 ...` nao casa */
    function close(){ ov.style.display = 'none'; document.documentElement.classList.remove('cl-sc-open'); }
    function open(){ ov.style.display = 'flex'; ov.scrollTop = 0; document.documentElement.classList.add('cl-sc-open'); }
    root.querySelectorAll('[data-cl-size-open]').forEach(function(b){
      b.addEventListener('click', open);
      b.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
    var x = ov.querySelector('.size_close');
    if (x) {
      x.addEventListener('click', close);
      x.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); close(); } });
    }
    ov.addEventListener('click', function(e){ if (e.target === ov) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && ov.style.display === 'flex') close(); });
  }

  /* app blocks (Kaching etc.) que o operador inserir na main-product ficam escondidos pelo CSS
     que oculta os blocos nativos: movemos para o slot onde o widget dele ficava */
  function initAppSlot(root){
    var slot = root.querySelector('[data-cl-app-slot]'); if (!slot) return;
    var sec = root.closest('.shopify-section') || document;
    sec.querySelectorAll('.shopify-app-block, [id^="shopify-block-"]').forEach(function(b){
      if (root.contains(b)) return;
      slot.appendChild(b);
    });
  }

  /* sticky ATC do tema dele (bottom:-200px ate o botao principal sair da tela) */
  function initSticky(root){
    var bar = root.querySelector('.clx-sticky-atc'); if (!bar) return;
    var main = root.querySelector('.clx-product-form__buttons [data-cl-atc]'); if (!main) return;
    /* fica DENTRO da secao: o CSS escopado (.cl-sec-pd00 .clx-sticky-atc{position:fixed}) so casa ali */
    function upd(){
      var r = main.getBoundingClientRect();
      var show = r.bottom < 0;
      bar.style.setProperty('bottom', show ? '0px' : '-200px');
      bar.style.setProperty('top', 'auto');
    }
    window.addEventListener('scroll', upd, {passive: true}); upd();
  }

  function init(){
    document.querySelectorAll('[data-cl-pdp]').forEach(function(root){
      if (root.__cl) return; root.__cl = true;
      var gal = initGallery(root);
      initVariants(root, gal);
      initSizeChart(root);
      initAppSlot(root);
      initSticky(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
